<template>
  <div>
    <InboxInfoDialog ref="inboxInfoDialog"></InboxInfoDialog>
    <v-row>
        <!--Define its full width - needed?-->
      <v-col md="12">
        <v-row>
          <v-col md="12">
            <div class="pb-5 d-flex">
              <span class="display-1 pt-1 font-weight-bold">{{$t('inbox.general.Messages and Comments')}}</span>
              <span>
                <v-btn :title="$t('inbox.general.Click to see more information')" @click.stop="$refs.inboxInfoDialog.openDialog()" icon large>
                  <v-icon color="primary">far fa-question-circle</v-icon>
                </v-btn>
              </span>
            </div>
          </v-col>
          <!--Incoming messages-->
          <v-col md="6">
            <v-row>
              <v-col md="12">
                <p class="text-center headline font-weight-bold">{{$t('inbox.general.Messages')}}</p>
                 <v-col md="12" v-for="item in myMessages" :key="item.id">
                  <v-card class="mx-auto" max-width="600" outlined>
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-title class="headline mb-1">{{item.title}}</v-list-item-title>
                        <v-list-item-subtitle class="subtitle-2 font-weight-bold">{{item.username}} {{$t('inbox.card.Messaged you')}} </v-list-item-subtitle>
                        <v-list-item-subtitle class="subtitle-2">{{item.uploaded}}</v-list-item-subtitle>
                        <v-divider></v-divider>
                        <v-row>
                          <v-col md="12">
                            <span>{{item.message}}</span>
                          </v-col>
                          <v-col md="12">
                            <span class="subtitle-1 pr-5 error--text" style="cursor: pointer;">{{$t('inbox.card.Report')}}</span>
                            <span class="subtitle-1 pr-5 success--text" style="cursor: pointer;">{{$t('inbox.card.Hide')}}</span>
                            <span class="subtitle-1 primary--text" style="cursor: pointer;">{{$t('inbox.card.Reply')}}</span>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-col>
              </v-col>
            </v-row>
          </v-col>
          <!--Latest comments-->
          <v-col md="6">
            <v-row>
              <v-col md="12">
                <p class="text-center headline font-weight-bold">{{$t('inbox.general.Comments')}}</p>
                 <v-col md="12" v-for="item in myArticleMessages" :key="item.id">
                  <v-card class="mx-auto" max-width="600" outlined>
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-title class="headline mb-1">{{item.title}}</v-list-item-title>
                        <v-list-item-subtitle class="subtitle-2 font-weight-bold">{{item.username}} {{$t('inbox.card.Left a comment on your article')}}</v-list-item-subtitle>
                        <v-list-item-subtitle class="subtitle-2">{{item.uploaded}}</v-list-item-subtitle>
                        <v-divider></v-divider>
                        <v-row>
                          <v-col md="12">
                            <span>{{item.message}}</span>
                          </v-col>
                          <v-col md="12">
                            <span class="subtitle-1 pr-5 error--text" style="cursor: pointer;">{{$t('inbox.card.Report')}}</span>
                            <span class="subtitle-1 pr-5 success--text" style="cursor: pointer;">{{$t('inbox.card.Hide')}}</span>
                            <span class="subtitle-1 primary--text" style="cursor: pointer;">{{$t('inbox.card.Reply')}}</span>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-col>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import messages from "./modules/lang/main/export";
import InboxInfoDialog from "@/components/informational_dialogs/private/inbox_info_dialog.vue";
export default {
  i18n: { messages },
  components:{
    InboxInfoDialog
  },
  data(){
    return{
      inboxInfoDialog: false,
      // Inbox message
      myMessages:[
        {id:1, username:"Bob", title:"Inspiring content", uploaded:"2020.01.01", message:"Best content evah! That brah, is some TED Talk content right there!"},
        {id:2, username:"Neighbour Kate", title:"Life changing article", uploaded:"2020.01.01", message:"After reading about your article regarding waste of soup, i began keeping it in a bag with me.  #noWasteSoup"},
        {id:3, username:"Rich prince", title:"Want 11 mill?", uploaded:"2020.01.01", message:"You want moneh?. I got moneh.  You give me account, i share the moneh."},
        {id:4, username:"Wifey", title:"Fishy for dinner", uploaded:"2020.01.01", message:"Fish for dinner. Dont be late! Buy some garlic from the shop."},
        {id:5, username:"Smokey Jane", title:"Tip for an article", uploaded:"2020.01.01", message:"This didnt come from me, but those mole people are active again. Pls checkout the tunnels at risky-area 51"},
      ],
      // Article Comment
      myArticleMessages:[
        {id:1, username:"NotBob", article:"", title:"Dude! this is the shit", uploaded:"2020.01.01", message:"Best content evah! That brah, is some TED Talk content right there!"},
        {id:2, username:"Angry Joe", article:"", title:"Duplicate of MY article!", uploaded:"2020.01.01", message:"Hey! the word on the second line, in this article is the same as mine! Change of face the wrath of 1000s of angry joes! #AngryJoe"},
        {id:3, username:"Lester mcHopp", article:"", title:"Very nice", uploaded:"2020.01.01", message:"Very nice indeed."},
        {id:4, username:"Granny", article:"", title:"Some tips", uploaded:"2020.01.01", message:"Your writing sucks! should have spent more time on it, but noooo.  Those video games and flashy tech machines are more important."},
        {id:5, username:"Biggest fan", article:"", title:"Im your biggest fan!", uploaded:"2020.01.01", message:"Hey, im your biggest fan! I got the second largest collection of your toe nails. 2020!"},
      ],
      articleComments:[
        // its empty for now
      ],
      whoShared:[
        // Its empty for now
      ],
      articleContent:[
        // Perhaps not needed
      ]
    }
  }
}
</script>